<template>
  <div>
    <Modal
      v-model="modal.visible"
      title="选择设备"
      :width="1200"
      footer-hide
      :closable="false"
      @on-visible-change="visibeChange"
    >
      <div>
        <div class="filter-box">
          <div>
            <span class="subtitle">关键字搜索:</span>
            <Input
              v-model="search.key"
              placeholder="请输入站点名称或序列号"
              style="width: 220px; margin: 0 10px"
            />
            <span class="btn-filter" @click="getData()">筛选</span>
            <span class="btn" @click="reset">清空</span>
          </div>
          <!--  <div>
            <Checkbox style="margin: 10px 20px 0" v-model="isMachineAll">{{
                isMachineAll ? "取消全选" : "全选设备"
            }}</Checkbox>
          </div> -->
        </div>
        <Table
          :columns="machine_columns"
          :data="machine"
          ref="selection"
          @on-selection-change="selectTable"
        >
          <template slot-scope="{ row }" slot="status">
            <span>{{ status[row.status].name }}</span>
          </template>
        </Table>
        <div class="t-right" style="margin-top: 20px">
          <Page
            @on-change="pageChange"
            @on-page-size-change="sizeChange"
            :current="search.p + 1"
            :total="total"
            :page-size="10"
            show-elevator
            show-sizer
            show-total
          />
        </div>
        <div slot="footer" style="margin: 20px 30px; text-aligh: right">
          <Button @click="cancel">取消</Button>
          <Button
            v-preventReClick
            type="primary"
            @click="saveAddMachine"
            style="margin-left: 10px"
            >确定</Button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    value: Boolean,
    ids: String,
  },
  data() {
    return {
      modal: {
        visible: this.value,
        ids: [],
      },
      machine: [],
      machine_columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "序列号",
          width: 120,
          key: "sn",
        },
        {
          title: "站点",
          width: 160,
          key: "site_name",
        },
        {
          title: "地址",
          minWidth: 230,
          key: "address",
          show: true,
          tooltip: true,
          render: (h, data) => {
            return [h("span", {}, data.row.address + data.row.address_detail)];
          },
        },
      ],
      total: 0,
      isMachineAll: false,
      search: {
        p: 0,
        l: 10,
        meter: -1,
        key: "",
      },
      select: [],
    };
  },
  mounted() {
    this.modal.visible = this.show;
    this.getData();
  },
  methods: {
    ...mapActions(["MachineListConcise"]),
    sizeChange(l) {
      this.search.l = l;
      this.getData();
    },
    pageChange(p) {
      this.search.p = p - 1;
      this.getData();
    },
    getData() {
      let selectIds = this.modal.ids;
      this.MachineListConcise(this.search).then((res) => {
        res.data.map((item) => {
          selectIds.map((it) => {
            it = parseInt(it);
            if (item.id == it) {
              item._checked = true;
            }
          });
          this.select.map((it) => {
            if (item.id === it.id) {
              item._checked = true;
            }
          });
        });
        this.machine = res.data;
        this.total = res.total;
      });
    },
    reset() {
      this.search = {
        p: 0,
        l: 10,
        meter: 0,
        key: "",
      };
      this.getData();
    },
    selectTable(data) {
      console.log(data.length)
      const ids = data.map(item=>{
        return item.id;
      })
      this.select = data;
      /* if (data.length > 0) {
        let json = this.select.concat(data);
        let newJson = [];
        for (const item1 of json) {
          let flag = true; // 建立标记，判断数据是否重复，true为不重复
          for (const item2 of newJson) {
            if (item1.id == item2.id) {
              flag = false;
            }
          }
          if (flag) {
            // 判断是否重复
            newJson.push(item1);
          }
        }
        this.select = newJson;
      } else {
        let temp = [...this.select].filter((x) =>
          [...this.machine].every((y) => y.id !== x.id)
        );
        this.select = temp;
      } */
    },
    saveAddMachine() {
      let temp = [];

      /* this.select.map((item) => {
        if (temp.indexOf(item.id) === -1) {
          temp.push(item.id);
        }
      });
      let newlist = this.modal.ids.concat(temp);
      let newJson = [],
        idsArray = [];
      newlist.map((item) => {
        let flag = true;
        newJson.map((item2) => {
          if (item == item2) {
            flag = false;
          }
        });
        if (flag) {
          idsArray.push(item);
        }
      });

      let machine_ids;
      if (this.isMachineAll) {
        machine_ids = "all";
      } else {
        if (idsArray.length == 0) {
          this.$Message.error("请选择设备!");
          return;
        }
        machine_ids = idsArray.join(",");
      } */
      const machine_ids = this.select.map(item=>{
        return item.id;
      })


      this.$emit("selectResult", machine_ids.join(','));
      this.modal.visible = false;
    },
    selectAll() {
      this.isMachineAll = !this.isMachineAll;
    },
    cancel() {
      this.$emit("cancel", false);
      this.modal.visible = false;
    },
    visibeChange(visible) {
      if (visible == false) {
        this.$emit("cancel", false);
      }
    },
  },
  watch: {
    value() {
      this.modal.visible = this.value;
    },
    ids() {
      this.select = [];
      this.modal.ids = this.ids ? this.ids.split(",") : [];
      this.getData();
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
